module.exports = __webpack_public_path__ + "assets/img/up-time-logs.da2f4baf.svg";